// import React from 'react';
import React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';

import Page from '../../components/page';
// import Navbar from '@src/business-components/navbar';

import lazyLoadComp from '@src/utils/lazyLoadComp';

import cs from 'classnames';
import styles from './index.less';

const Navbar = lazyLoadComp(() => import('@src/business-components/navbar'));
const ScrollTips = lazyLoadComp(() => import('./components/scroll-tips'));
const FloatQrcode = lazyLoadComp(() => import('./components/float-qrcode'));
const HarmonyDownloadModal = lazyLoadComp(() => import('@src/business-components/harmony-download-modal'));

const Home = lazyLoadComp(() => import('./components/Home'));
const PublicBeta = lazyLoadComp(() => import('./components/public-beta'));
const Characteristics = lazyLoadComp(() => import('./components/Characteristics'));
const Introduced = lazyLoadComp(() => import('./components/Introduced'));
const Attention = lazyLoadComp(() => import('./components/Attention'));

const Main = () => {
  const {
    navbarStore,
    pageChangeStore,
    loadComponentsStore,
    omniDataHome,

    homeCompStore,
    publicBetaStore,
    characteristicsCompStore,
    introducedCompStore,
    attentionStore,
    isHarmonyDownloadModalOpen,
    closeHarmonyDownloadModal
  } = useStore(() => new MainStore());

  const comStyle = key => cs('page-item', { 'page-item_active': pageChangeStore.currentPage === key });

  return (
    <Page>
      <Navbar store={navbarStore} />
      <div className={styles['main-layout']} ref={pageChangeStore.pageContainerRef}>
        {loadComponentsStore.shouldRender('home') && <Home className={comStyle('home')} store={homeCompStore} />}
        {loadComponentsStore.shouldRender('publicBeta') && <PublicBeta className={comStyle('publicBeta')} store={publicBetaStore} />}
        {loadComponentsStore.shouldRender('characteristics') && <Characteristics className={comStyle('characteristics')} store={characteristicsCompStore} />}
        {loadComponentsStore.shouldRender('introduced') && <Introduced className={comStyle('introduced')} store={introducedCompStore} />}
        {loadComponentsStore.shouldRender('attention') && <Attention className={comStyle('attention')} store={attentionStore} />}
      </div>
      {pageChangeStore.currentPage !== 'attention' && <ScrollTips />}
      {pageChangeStore.currentPage !== 'home' &&
        !pageChangeStore.isFooterVisible && <FloatQrcode store={pageChangeStore} omniDataHome={omniDataHome} onClickWebsite={navbarStore.onClickWebsite} />}
      <HarmonyDownloadModal visible={isHarmonyDownloadModalOpen} downloadUrl={omniDataHome.down_link?.harmony} onClose={closeHarmonyDownloadModal} />
      <div id="OMNI__COMMON__FOOTER" />
    </Page>
  );
};

export default observer(Main);
